import React, { useEffect, useState } from 'react';
import { Save, Check } from 'lucide-react';
import api from '../../lib/api';
import { useContent } from '../../context/ContentContext';

const LABELS = {
  hero_eyebrow: { l: 'Hero - Eyebrow', textarea: false },
  hero_title: { l: 'Hero - Title', textarea: true },
  hero_intro: { l: 'Hero - Intro paragraph', textarea: true },
  hero_cta_label: { l: 'Hero - CTA button label', textarea: false },
  intro_section_title: { l: 'Home Intro Section - Title', textarea: false },
  intro_section_body: { l: 'Home Intro Section - Body', textarea: true },
  heart_title: { l: '“Heart of PM” - Title', textarea: false },
  heart_body: { l: '“Heart of PM” - Body', textarea: true },
  contact_email: { l: 'Contact form recipient email', textarea: false },
  public_phone: { l: 'Public phone', textarea: false },
  public_address: { l: 'Public address (single line)', textarea: false },
};

export default function Content() {
  const { content, reload } = useContent();
  const [drafts, setDrafts] = useState({});
  const [saved, setSaved] = useState({});

  useEffect(() => { setDrafts(content); }, [content]);

  const save = async (key) => {
    await api.put(`/content/${key}`, { value: drafts[key] ?? '' });
    setSaved((s) => ({ ...s, [key]: true }));
    setTimeout(() => setSaved((s) => ({ ...s, [key]: false })), 1600);
    reload();
  };

  const keys = Object.keys(LABELS);

  return (
    <div>
      <h1 className="font-serif text-cream-50 text-3xl">Content</h1>
      <p className="text-cream-100/60 text-sm mt-1">Tweak the wording that appears on the public site. Save each field individually.</p>
      <div className="mt-8 space-y-5">
        {keys.map((k) => {
          const cfg = LABELS[k];
          return (
            <div key={k} className="bg-forest-900 border border-forest-800 p-5">
              <div className="flex justify-between items-center mb-2">
                <label className="text-cream-100/80 text-sm font-medium">{cfg.l}</label>
                <span className="text-[11px] text-cream-100/40 font-mono">{k}</span>
              </div>
              {cfg.textarea ? (
                <textarea value={drafts[k] ?? ''} onChange={(e) => setDrafts({ ...drafts, [k]: e.target.value })} rows={4} className="w-full bg-forest-950 border border-forest-800 focus:border-sage-500 outline-none px-3 py-2 text-sm text-cream-50 resize-none" />
              ) : (
                <input value={drafts[k] ?? ''} onChange={(e) => setDrafts({ ...drafts, [k]: e.target.value })} className="w-full bg-forest-950 border border-forest-800 focus:border-sage-500 outline-none px-3 py-2 text-sm text-cream-50" />
              )}
              <div className="mt-3 flex justify-end">
                <button onClick={() => save(k)} className="inline-flex items-center gap-2 bg-sage-500 text-forest-900 text-sm px-4 py-2 hover:bg-sage-600 transition-colors">
                  {saved[k] ? <><Check className="h-4 w-4" /> Saved</> : <><Save className="h-4 w-4" /> Save</>}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
